import React from 'react';
import {useState, useEffect, useRef} from 'react';
import hoc from './FieldHOC';
import config from 'config';

let tpegTimer = null;

function TpegTitle(props){
  const [title, setTitle] = useState('');
  const [error, setError] = useState(false);
  const [available, setAvailable] = useState(false);
  const [checkingAvailability, setCheckingAvailability] = useState(false);

  const titleChanged = (e) => {
    const value = e.target.value;
    setTitle(value);
    setCheckingAvailability(true);
    setAvailable(false);
    setError(false);
    clearTimeout(tpegTimer);
    tpegTimer = setTimeout(() => {
      $.post(config.API_ROOT + '/tpeg-availability', {
        tpeg_title: value
      }).then((r) => {
        setCheckingAvailability(false);
        if (!r.available) {
          setAvailable(false);
          setError('The name you selected is not available. Please try again.');
        } else {
          setAvailable(true);
          setError(false);
        }
      });
    }, 500);
    props.onChange(value);
  };

  const groupClass = !error ? 'form-group' : 'form-group has-error';
  const checkingClass = checkingAvailability ? ' has-info' : '';
  const availableClass = available ? ' has-success' : '';
  return <div className={groupClass + checkingClass + availableClass}>
    <label className="control-label">{props.title || props.field.get('title')}</label>
    <input type="text" name={props.name} tabIndex={props.tabIndex} className="form-control" value={title} onChange={titleChanged} />
    {error ? <span className="help-block">{error}</span> : null}
    {checkingAvailability ? <span className="help-block">Checking title availability...</span> : null}
    {available ? <span className="help-block">Username is available.</span> : null}
  </div>;

}

export default hoc(TpegTitle);
